module.exports = ".checkbox-wrapper:not(:first-child) {\n  margin-top: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/step-parcours-lbpa/sign/sign.component.scss
// module id = cR3u
// module chunks = 1